<div style="width: 400px">
  <ng-container *ngFor="let actor of actors">
    <hw-form-item [name]="actor" [label]="'integration.policy-provision.' + actor">
      <hw-codesystem-concept-radio
        [(ngModel)]="val[actor]"
        *ngIf="!(actor | format : readonlyActor)"
        (ngModelChange)="fireOnChange()"
        [disabled]="disabled"
        [name]="actor"
        codesystem="policy-provision-type"></hw-codesystem-concept-radio>
      <div *ngIf="actor | format : readonlyActor">
        {{ val[actor] | localizedConceptName : 'policy-provision-type' | async }}
      </div>
    </hw-form-item>
  </ng-container>
</div>
